module.exports = __webpack_public_path__ + "static/media/iconSepultacionSep.4e3848c7.svg";